import React, { useEffect } from 'react';
import { useCreateSensorMutation, useGetAllSensorTypeQuery } from '../../services/building';
import { Button, Modal, Textfield, Text, Box, Select } from '@ies-ds/react-ui';
import { useForm } from 'react-hook-form';
import styled from 'styled-components';

const StyledDefatultDisabledOption = styled.option`
  [disabled] {
    color: #999;
  }
`;

const SensorCreate = ({ id, building }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const { handleSubmit, register, reset } = useForm();

  const [createSensor, { isSuccess, reset: resetCreate }] = useCreateSensorMutation();

  const onSubmit = (data) => {
    console.log(data);
    createSensor({
      ...data,
      name: data.name,
      buildingId: parseInt(building.id),
      zoneId: parseInt(data.zoneId),
      floorId: parseInt(data.floorId),
      sensorTypeId: parseInt(data.sensorTypeId),
      channel: data.channel,
    });
    reset({ name: '', floorId: '', zoneId: '', sensorTypeId: '', channel: '' });
  };

  useEffect(() => {
    reset({ name: '', floorId: '', zoneId: '', sensorTypeId: '', channel: '' });
    resetCreate();
  }, [isOpen, reset]);

  return (
    <>
      <Button color="primary" onClick={() => setIsOpen(true)}>
        Add Sensor
      </Button>
      <Modal
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
        closeButton
      >
        <Modal.Header>
          <Text size="large" weight="bold">
            Add New Sensor
          </Text>
        </Modal.Header>
        <Modal.Content>
          {isSuccess && (
            <>
              <p style={{ color: 'green' }}>Sensor created successfully</p>
              <br />
            </>
          )}

          <Textfield
            label="Name"
            {...register('name', { required: true })}
            required
            placeholder="Choose a name for the sensor"
          />
          <Select label="Choose Floor" {...register('floorId')}>
            <option value="" selected disabled hidden>
              Please select
            </option>
            {building.floors.map((floor) => (
              <option value={floor.id}>{floor.name}</option>
            ))}
          </Select>
          <Select label="Choose Zone" {...register('zoneId')}>
            <option value="" selected disabled hidden>
              Please select
            </option>
            {building.zones.map((zone) => (
              <option value={zone.id}>{zone.name}</option>
            ))}
          </Select>
          <Select label="Sensor Type" {...register('sensorTypeId')}>
            <option value="" selected disabled hidden>
              Please select
            </option>
            <option value={1}>Temperature</option>
            <option value={2}>CO₂</option>
            <option value={3}>Relative Humidity</option>
            <option value={4}>Light</option>
            {/* {building.zones.map((zone) => (
              <option value={zone.id}>{zone.name}</option>
            ))} */}
          </Select>
          <Textfield
            label="Channel ID"
            required
            {...register('channel', { required: true })}
            placeholder="i.e. SC000030"
          />
        </Modal.Content>
        <Modal.Footer>
          <Box gap={6}>
            <Button color="primary" onClick={handleSubmit(onSubmit)}>
              Create
            </Button>
            <Button
              onClick={() => {
                setIsOpen(false);
              }}
            >
              Close
            </Button>
          </Box>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SensorCreate;
